// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const UserProvisionOut = zod.object({
  "display_name": zod.string(),
  "email": zod.string(),
  "id": zod.uuid(),
  "is_active": zod.boolean(),
  "notice": zod.union([zod.string(),zod.null()]).optional(),
  "provisioned_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "signed_in": zod.boolean()
});

export type UserProvisionOut = zod.input<typeof UserProvisionOut>;
export type UserProvisionOutOutput = zod.output<typeof UserProvisionOut>;
